<div class="container container-main">
  <app-dashboard-header #dashboardHeader :dashboardType="learner" />
  <div class="row mb-3">
    <div class="col-xl-8">
      <ng-container *ngIf="smartAssistantEnabled">
        <div class="row mb-3">
          <div class="col">
            <app-glai />
          </div>
        </div>
      </ng-container>
      <div class="row mb-3">
        <div class="col">
          <app-card-current-competencies />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <app-card-todos />
        </div>
        <div class="col-md-6">
          <app-card-ideas />
        </div>
      </div>
      <div *ngIf="!smartAssistantEnabled" class="row mb-3">
        <div class="col">
          <app-recent-celebration />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-card-recent-badges *ngIf="user" [userId]="user.id" />
        </div>
      </div>
    </div>
    <div class="col-xl-4">
      <app-card-upcoming-sessions
        class="d-block mb-3"
        [showCreateSessionButton]="false" />

      <ng-container *ngIf="instantFeedbackEnabled">
        <app-card-smart-feedback />
      </ng-container>

      <div *ngIf="mscEnabled" class="row mb-3">
        <div class="col">
          <app-card-mysmartcoach [user]="user" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-growth-snapshot />
        </div>
      </div>
    </div>
  </div>
</div>
